import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { CategoryDropdown, DataQualityDropdown } from "./SupplierCards";
import { YearDropdown } from "../components/FootPrint";
import { Flex } from "@chakra-ui/react";
import assert from "utils/assert";
import * as React from "react";
import { ScopeDropdown } from "./SupplierTrends";
/**
 * @typedef {Object} Filters
 * @property {number} year
 * @property {string[]} categories
 * @property {"ALL"|"VERIFIED"|"UNVERIFIED"|"MIXED"} dataQuality
 */

/**
 * @param {Object} props
 * @param {Filters} props.filters
 * @param {Function} props.setFilters
 * @param {("category"|"quality"|"year")[]} [props.showFilters=["category","quality","year"]]
 */
export default function SupplierFiltersCatQualityYear({
  filters,
  setFilters,
  showFilters = ["category", "quality", "year", "scope"],
  align = "end",
}) {
  assert(setFilters);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (filters) {
      return;
    }
    // Initialize from URL params
    const initialYear = Number(searchParams.get("year")) || new Date().getFullYear();
    const catParams = searchParams.getAll("categories");
    const initialCategories = catParams || [];
    const initialDataQuality = searchParams.get("dataQuality") || "ALL";
    const initialScope = searchParams.get("scope") || "All Scopes";

    setFilters({
      year: initialYear,
      categories: initialCategories,
      dataQuality: initialDataQuality,
      scope: initialScope,
    });
  }, [filters, searchParams, setFilters]);

  const setYear = (year) => {
    setFilters({ ...filters, year });
  };
  const setCategories = (categories) => {
    if (typeof categories === "function") {
      // CategoryDropdown uses prev => ...
      categories = categories(filters?.categories);
    }
    assert(!categories || Array.isArray(categories), categories);
    setFilters({ ...filters, categories });
  };
  const setDataQuality = (dataQuality) => {
    setFilters({ ...filters, dataQuality });
  };

  const setScope = (scope) => {
    setFilters({ ...filters, scope });
  };

  // Update URL params when year or dimension changes
  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    if (filters?.year) {
      params.set("year", filters?.year);
    } else {
      params.delete("year");
    }

    params.delete("categories"); // Clear existing categories to avoid duplicates
    // Append each category to the URL params
    filters?.categories?.forEach((name) => {
      if (name) {
        params.append("categories", name);
      }
    });

    if (filters?.dataQuality) {
      params.set("dataQuality", filters?.dataQuality);
    } else {
      params.delete("dataQuality");
    }

    if (filters?.scope) {
      params.set("scope", filters?.scope);
    } else {
      params.delete("scope");
    }

    setSearchParams(params);
  }, [filters, searchParams, setSearchParams]);

  return (
    <Flex alignSelf={align === "start" ? "flex-start" : "end"} gap={2}>
      {showFilters.includes("category") && (
        <CategoryDropdown selected={filters?.categories || []} setSelected={setCategories} />
      )}
      {showFilters.includes("quality") && (
        <DataQualityDropdown selected={filters?.dataQuality} setSelected={setDataQuality} />
      )}
      {showFilters.includes("year") && <YearDropdown setYear={setYear} selectedYear={filters?.year} />}
      {showFilters.includes("scope") && <ScopeDropdown setSelected={setScope} selected={filters?.scope} />}
    </Flex>
  );
}
